<iframe *ngIf="src" [src]="src" id="youtubeIframe" #iframeYoutube
  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowfullscreen></iframe>